import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';

import { App } from './App.tsx';
import { queryClient } from './api/queryClient.ts';
import { startInstallOffer } from './features/install/installStore.ts';
import { applyOpenTarget } from './features/notifications/openTarget.ts';
import { trackKeyboardInset } from './ui/keyboardInset.ts';
import './styles/global.css';

// Before the first render: the property is read by the shell's own height, and starting
// at the default of 0px is correct on a device with no soft keyboard.
trackKeyboardInset();

// Also before the first render, and for a stricter reason: Chrome dispatches
// `beforeinstallprompt` during page load and only once. A listener attached from a
// component effect misses it, and with it the only way to open the install dialog.
startInstallOffer();

// Before the first render too, and for a similar reason: a tapped notification arrives as
// `?group=…&list=…`, and both switchers seed their state from localStorage when they mount.
// Written any later, the selection would be ignored until something remounted them — so
// the notification would open the app on whichever list was showing last.
applyOpenTarget();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element — index.html is not the document being served.');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
